export function replacePatientIdFromRoutes(route: string, patientId: string) {
    return route.replace(":documentPatient", patientId).replace(":patientId", patientId);
}